import React from 'react';

/**
 * Generic error state with an optional retry affordance.
 * Props: { title, message, onRetry }
 */
const ErrorState = ({ title = 'Couldn’t load this view', message, onRetry }) => (
  <div className="au-state" data-testid="au-error">
    <div className="au-state__icon" aria-hidden="true">⚠️</div>
    <p className="au-state__title">{title}</p>
    <p className="au-state__msg">{message || 'Something went wrong while loading the data.'}</p>
    {onRetry ? (
      <button type="button" className="au-state__btn" onClick={onRetry}>Retry</button>
    ) : null}
  </div>
);

export default ErrorState;
